import * as React from 'react';
import styled from 'styled-components/macro';
import UserMenu from '../UserMenu';

export function Nav() {

  return (
    <Wrapper>
      <Item>
        <UserMenu />
      </Item>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  display: flex;
  margin-right: -1rem;
`;

const Item = styled.a`
  color: ${p => p.theme.background};
  text-decoration: none;
  display: flex;
  padding: 0.25rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  align-items: center;

  .icon {
    margin-right: 0.25rem;
  }
`;
